<template>
  <div class="goodsBox">
    <el-tabs
      v-model="listQuery.productRemark"
      @tab-click="
        () => {
          getFilterOptions()
          onSearch()
        }
      "
      :stretch="true"
    >
      <el-tab-pane
        v-for="(item, index) in columnList"
        :key="index"
        :label="item.name"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>

    <div class="box_biankuang_shuaixuan">
      <div class="box_filter_xilie">
        <span class="screeningTltle">大类：</span>
        <div class="box_fliter_xl_gengduo">
          <div
            v-for="item in dlOptions"
            :key="item"
            class="box_fliter_xl_mc"
            :class="{
              active: listQuery.eosGeneraName === item,
            }"
            @click="onFilter('eosGeneraName', item)"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="box_filter_xuxian"></div>

      <div class="box_filter_xilie" v-if="plOptions.length !== 0">
        <span class="screeningTltle">品类：</span>
        <div class="box_fliter_xl_gengduo">
          <div
            v-for="item in plOptions"
            :key="item"
            class="box_fliter_xl_mc"
            :class="{
              active: listQuery.productCategoryName === item,
            }"
            @click="onFilter('productCategoryName', item)"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="box_filter_xuxian" v-if="xlOptions.length !== 0"></div>

      <div class="box_filter_xilie" v-if="xlOptions.length !== 0">
        <span class="screeningTltle">系列：</span>
        <div class="box_fliter_xl_gengduo">
          <div
            v-for="item in xlOptions"
            :key="item"
            class="box_fliter_xl_mc"
            :class="{
              active: listQuery.series === item,
            }"
            @click="onFilter('series', item)"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div
        class="box_filter_xuxian"
        v-if="supperNameOptions.length !== 0"
      ></div>

      <div class="box_filter_xilie" v-if="supperNameOptions.length !== 0">
        <span class="screeningTltle">供应商：</span>
        <div class="box_fliter_xl_gengduo">
          <div
            v-for="item in supperNameOptions"
            :key="item"
            class="box_fliter_xl_mc"
            :class="{
              active: listQuery.supperName === item,
            }"
            @click="onFilter('supperName', item)"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="box_filter_xuxian"></div>

      <div class="box_filter_xilie">
        <span class="screeningTltle">款号：</span>
        <el-input
          placeholder="请输入，多个用换行符或逗号分隔"
          prefix-icon="el-icon-search"
          v-model="listQuery.styleNumberList"
          @keyup.enter.native="onSearch()"
          style="width: 300px"
          clearable
        ></el-input>
        <div class="searchClass" style="margin-left: 10px" @click="onSearch()">
          搜索
        </div>
      </div>
    </div>

    <div
      v-loading="loading"
      element-loading-text="正在加载数据"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0,.1)"
      class="loadingClass"
    >
      <div :class="['box_Img', 'box_Img_top', 'box_ImgActive']">
        <div
          v-for="(item, index) in dataList"
          class="box_Img_list"
          :class="{
            sellout: item.saleOutStatus,
          }"
          @click="getitem(item)"
          :key="index"
        >
          <div class="box_sellout" v-if="item.saleOutStatus">
            售罄
          </div>

          <div class="box_Img_chirld">
            <img :src="item.imgPath" alt class="img_chirld" />
          </div>
          <div class="box_detail_name">
            <div style="display: inline-block">
              <div class="box_SP_bianhao">
                {{ item.styleNumber }}
              </div>
              <div class="box_SP_title">
                {{ item.productName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="+total === 0" style="text-align:center; margin:60px 0">
      <img src="@/assets/img/noData.png" alt />
    </div>
    <div class="boe_fenye" v-else>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.current"
        :page-sizes="[20, 40, 60, 100]"
        :page-size="listQuery.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getGoodsList, getColumnList, getFilterOptions } from '@/api/homeApi'
import { interestedIn } from '@/api/detailsApi'
import ls from '@/utils/localStorage'

export default {
  components: {},
  data() {
    return {
      loading: false,
      dataList: [],
      total: 0,
      listQuery: {
        productRemark: '本地生活',
        eosGeneraName: null,
        productCategoryName: null,
        series: null,
        supperName: null,
        current: 1,
        size: 20,
        styleNumberList: null,
      },
      columnList: [
        { name: '本地生活' },
        { name: '潮流爆款' },
        { name: '精品严选' },
      ],
      isFristTips: true,
      dlOptions: [],
      plOptions: [],
      xlOptions: [],
      supperNameOptions: [],
      userData: ls.get('userData'),
    }
  },
  mounted() {
    if (this.userData.username === '0114') {
      this.listQuery.productRemark = '潮流爆款'
      this.columnList = [{ name: '潮流爆款' }, { name: '景翠直播' }]
    } else {
      this.getColumnList()
    }

    this.getFilterOptions()
    this.getList()
  },
  methods: {
    getFilterOptions() {
      this.listQuery.eosGeneraName = null
      this.listQuery.productCategoryName = null
      this.listQuery.series = null
      this.listQuery.supperName = null
      this.listQuery.styleNumberList = null

      getFilterOptions({
        productRemark: this.listQuery.productRemark,
      }).then((res) => {
        this.dlOptions = res.data.eosGeneraName || []
        this.plOptions = res.data.productCategoryName || []
        this.xlOptions = res.data.series || []
        this.supperNameOptions = res.data.supperName || []
      })
    },

    onFilter(key, val) {
      if (this.listQuery[key] === val) {
        this.listQuery[key] = null
      } else {
        this.listQuery[key] = val
      }
      this.getList()
    },

    getColumnList() {
      getColumnList().then((res) => {
        this.columnList = res.data
      })
    },

    handleParams(value) {
      if (!value) {
        return null
      }
      return value
        .replace(/\n/g, ',')
        .replace(/，/g, ',')
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item)
    },

    getList() {
      this.loading = true
      getGoodsList({
        ...this.listQuery,
        styleNumberList: this.handleParams(this.listQuery.styleNumberList),
      })
        .then((res) => {
          this.dataList = res.data.records || []
          this.total = res.data.total

          if (this.listQuery.productRemark !== '本地生活' && this.isFristTips) {
            this.$alert(
              '“潮流爆款”、“精品严选”为自定义货品，所有门店均可下单，但目前自定义货品链接上架仅对缴费门店开放，非缴费门店无上架权限。',
              '温馨提示',
              {
                confirmButtonText: '确定',
                callback: () => {
                  this.isFristTips = false
                },
              },
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getInterest(item) {
      let obj = {
        id: item.id,
        isLike: +item.isLike === 0 ? 1 : 0,
      }
      interestedIn(obj).then((res) => {
        if (res.code === 0) {
          this.getList()
        }
      })
    },

    onSearch() {
      this.listQuery.current = 1
      this.getList()
    },

    // 分页组件切换页数
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getList()
    },

    // 分页组件切换
    handleCurrentChange(val) {
      this.listQuery.current = val
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.getList()
    },

    // 点击跳转详情页
    getitem(data) {
      let routeData = this.$router.resolve({
        path: '/plaingold',
        query: {
          id: data.id,
          styleNumber: data.styleNumber,
        },
      })
      // 打开新页面
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style scoped lang="scss">
.salesNumbersClassActive {
  color: #ec9368;
}

.home_sort .el-input__inner {
  padding: 0px 10px;
}

.el-scrollbar__view .selected {
  color: #cdcdcd;
}

.el-scrollbar__view li {
  color: #ec9368;
}

.box_SP_bianhao {
  margin-top: 15px;
  font-size: 16px;
  margin-left: 5px;
  color: #ec9368;
}

.box_SP_title {
  font-size: 16px;
  color: #000;
  margin: 10px 0 10px 5px;
  width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.box_filter_shaixuan .el-tag {
  background-color: #fff2ea;
  border-radius: 0;
  /* width: 114px; */
  font-size: 16px;
  color: #000;
  margin-left: 18px;
  color: #ec9368;
  font-size: 16px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #ec9368;
}

.box_filter_shaixuan .el-tag i::before {
  line-height: 30px;
}

.box_filter_shaixuan .el-tag i {
  border-radius: 0;
  width: 30px;
  color: #000;
  height: 30px;
  left: 10px;
  top: -3px;
}
</style>

<style scoped lang="scss">
@import '@/style/homeList.scss';

.goodsBox {
  max-width: 1500px;
  margin: 0 auto;
  background-color: #ffffff;

  /deep/ .el-tabs__header {
    margin: 0 !important;
  }

  /deep/ .el-tabs__item {
    height: 50px;
    line-height: 50px;
  }
}

.searchClass {
  height: 40px;
  line-height: 40px;
  background: #ec9368;
  color: #fff;
  width: 60px;
  text-align: center;
  font-size: 16px;
  border-radius: 30px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
